import { assign } from 'lodash';

export default {
  data() {
    const locale = this.$store.getters.translations;

    return {
      items: [],
      loading: true,
      locale: {
        noDataText: locale.tableNoDataText,
        noResultsText: locale.tableNoResultsText,
        rowsPerPageText: locale.tableRowsPerPageText,
        searchLabel: locale.fieldSearchLabel,
      },
      pagination: {
        rowsPerPage: 25,
        page: 1,
        sortBy: 'id',
        descending: true,
      },
      rowsPerPageItems: [5, 10, 25, 50, 100],
      totalCount: 0,
    };
  },
  watch: {
    pagination: {
      handler() {
        if (!this.loading) {
          this.loadPage();
        }
      },
      deep: true,
    },
  },
  computed: {
    apiPagination() {
      return {
        pageSize: this.pagination.rowsPerPage,
        page: this.pagination.page,
        sortBy: this.pagination.sortBy,
        sortOrder: this.pagination.descending ? 'DESC' : 'ASC',
      };
    },
    apiParams() {
      return assign({},
        this.apiFilters,
        this.apiPagination,
        this.apiSearch);
    },
    apiSearch() {
      return {
        search: this.search,
      };
    },
  },
};
